// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u7b8","question":"styles_question__VcPgp","description":"styles_description__1j4zG"};